// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Layout odds and ends that have no natural home in a component.
 *
 * This file used to carry the Semantic UI overrides from before the Radix
 * migration (\`.ui.form\`, \`.ui.primary.button\`, \`.ui.grid\`, the orange banner,
 * the completed/incomplete menu tints). None of those selectors matched any
 * markup any more, so they went with the design-system redesign. Base
 * typography and colour now live in \`styles/globals.css\`; everything visual
 * belongs in a component or in the design system.
 */

#app {
    height: 100%;
}

/* Required-field marker on a field label — the design system's \`.form-required\`
   expressed as a pseudo-element, because the label text is rendered by
   item_field and has no slot for a <span>. */
label.mandatory-field::after {
    content: '*';
    margin-left: 0.15em;
    color: var(--color-danger-900);
}

label.optional-field {
    font-weight: 400;
}

#mainContent hr {
    width: 60%;
    margin-top: 2em;
    margin-bottom: 2em;
    border-top: 1px solid var(--color-gray-200);
}

@media print {
    .no-print, .no-print * {
        display: none !important;
    }

    #app > div {
        display: block !important;
    }

    #mainContent {
        width: 100% !important;
        padding-right: 40px !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/layout.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF;IACI,YAAY;AAChB;;AAEA;;6CAE6C;AAC7C;IACI,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,8BAA8B;IAClC;AACJ","sourcesContent":["/*\n * Layout odds and ends that have no natural home in a component.\n *\n * This file used to carry the Semantic UI overrides from before the Radix\n * migration (`.ui.form`, `.ui.primary.button`, `.ui.grid`, the orange banner,\n * the completed/incomplete menu tints). None of those selectors matched any\n * markup any more, so they went with the design-system redesign. Base\n * typography and colour now live in `styles/globals.css`; everything visual\n * belongs in a component or in the design system.\n */\n\n#app {\n    height: 100%;\n}\n\n/* Required-field marker on a field label — the design system's `.form-required`\n   expressed as a pseudo-element, because the label text is rendered by\n   item_field and has no slot for a <span>. */\nlabel.mandatory-field::after {\n    content: '*';\n    margin-left: 0.15em;\n    color: var(--color-danger-900);\n}\n\nlabel.optional-field {\n    font-weight: 400;\n}\n\n#mainContent hr {\n    width: 60%;\n    margin-top: 2em;\n    margin-bottom: 2em;\n    border-top: 1px solid var(--color-gray-200);\n}\n\n@media print {\n    .no-print, .no-print * {\n        display: none !important;\n    }\n\n    #app > div {\n        display: block !important;\n    }\n\n    #mainContent {\n        width: 100% !important;\n        padding-right: 40px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
